import React, { useCallback } from "react";
import { useHistory, useLocation } from "react-router";
import classNames from "../utils/classNames";

interface Props {
  className?: string;
}

const BuyHotspotsButton: React.FC<Props> = ({ className = "" }) => {
  const history = useHistory();
  const location = useLocation();

  const ope5gRewardsCalculator = useCallback(
    () => history.push("/helium-5g-genesis-mobile-rewards-calculator"),
    [history]
  );

  if (
    location.pathname.includes("helium-5g-genesis-mobile-rewards-calculator")
  ) {
    return null;
  }

  return (
    <button
      onClick={ope5gRewardsCalculator}
      type="button"
      className={classNames(
        className,
        "px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-hotspotty-400 hover:bg-hotspotty-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-hotspotty-400 disabled:opacity-50 disabled:cursor-default"
      )}
    >
      <span className="mr-1">Calculate 5G rewards</span> 🚀
    </button>
  );
};

export default BuyHotspotsButton;
